import FormText from 'components/form/FormText';
import IndicatorButton from 'components/indicator/IndicatorButton';
import { AppConst } from 'constants/appConst';
import { useInvitationUser } from './hooks/useInvitationUser';

import type { JSX } from 'react';

/**
 * 招待受付ユーザー情報入力画面
 * ロジックは useInvitationUser に委譲し、JSX のみを担当する。
 */
export default function InvitationUser(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const { register, errors, processing, onAccept } = useInvitationUser();

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <section className="section-login">
        <div className="container">
          <div className="card card-login">
            <div className="card-body">
              <h1 className="card-title">アカウント登録</h1>
              <p className="lead">アカウントを登録してください。</p>

              <form className="form-login">
                <div>
                  <FormText
                    subject="氏名"
                    name="userName"
                    register={register}
                    errors={errors}
                    required={true}
                    maxLength={100}
                    requiredMark={true}
                  />
                </div>
                <div></div>
                <div className="form-footer mt-4">
                  <button
                    type="button"
                    className="btn btn-submit w-100"
                    onClick={onAccept}
                    disabled={processing}
                  >
                    <IndicatorButton visible={processing} />
                    BranQをはじめる
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="text-center">
            <a href={AppConst.url.privacy} target="_blank" className="caption">
              privacy &amp; Terms
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
